import React from 'react';
import Router from './features/router/Router';
import "@blocknote/core/fonts/inter.css";
import "@blocknote/mantine/style.css";

// import { CssVarsProvider } from '@mui/joy/styles';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { useReturnCurrentUser } from './features/user/userSlice';




function App() {

  const currentUser = useReturnCurrentUser()

  const isDarkMode = currentUser.theme === 'dark';

  const theme = createTheme({
    palette: {
      primary: {
        light: '#0B2447',
        main: isDarkMode ? '#f05f2a' : '#0B2447', // #0B2447 #f05f2a  #bebebe
        dark: isDarkMode ? '#c8491b' : '#0B2447', 
        contrastText: '#fff',
      },
      secondary: {
        light: '#828387',
        main: '#454649', // #454649
        dark: '#636569',
        // contrastText: '#000',
      },
      mode: isDarkMode ? "dark" : "light"
    },
});

  return (
     
        <ThemeProvider theme={theme}>
           {/* <CssVarsProvider> */}
              <Router />
          {/* </CssVarsProvider> */}
        </ThemeProvider>
  );
}

ModuleRegistry.registerModules([AllCommunityModule]);


export default App;
